<ng-container *ngIf="control">
	<ng-container *ngIf="labelTemplate">
		<ng-template [ngTemplateOutlet]="labelTemplate"></ng-template>
	</ng-container>

	<ng-container *ngIf="!labelTemplate">
		<label class="mb-2" [for]="formControlName">{{ label }}</label>
		<span *ngIf="!isRequired" class="optional-field">
			({{ "GLOBAL.OPTIONAL_FIELD" | translate }})
		</span>
	</ng-container>

	<ng-container [ngSwitch]="mode">
		<div
			[class.input-group]="
				!!inputGroupIconText || leftInputGroup || rightInputGroup
			"
		>
			<span
				*ngIf="
					!!inputGroupIconText && inputGroupIconPosition === 'left'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				{{ inputGroupIconText }}
			</span>

			<ng-container [ngTemplateOutlet]="leftInputGroup"></ng-container>

			<ng-container *ngSwitchCase="'decimal'">
				<input
					appNumber
					class="form-control"
					[id]="formControlName"
					[class.is-invalid]="errors && control.dirty"
					[class.rounded-end]="loading"
					[formControl]="control"
					[placeholder]="placeholder"
				/>
				@if (!!helperText) {
					<small id="formControlName" class="form-text text-muted">{{
						helperText
					}}</small>
				}
			</ng-container>

			<ng-container *ngSwitchCase="'currency'">
				<input
					appCurrency
					class="form-control"
					aria-describedby="atlasInput"
					[id]="formControlName"
					[class.is-invalid]="errors && control.dirty"
					[class.rounded-end]="loading"
					[formControl]="control"
					[placeholder]="placeholder"
					[updateCurrencyProgrammatically]="
						updateCurrencyProgrammatically
					"
					[decimalPlaces]="decimalPlaces"
				/>
				@if (!!helperText) {
					<small id="formControlName" class="form-text text-muted">{{
						helperText
					}}</small>
				}
			</ng-container>

			<ng-container *ngIf="loading && inputGroupIconPosition !== 'right'">
				<div class="position-absolute loader-container">
					<i class="position-relative loader"></i>
				</div>
			</ng-container>

			<span
				*ngIf="
					!!inputGroupIconText && inputGroupIconPosition === 'right'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				{{ inputGroupIconText }}
			</span>

			<ng-container [ngTemplateOutlet]="rightInputGroup"></ng-container>
		</div>

		<ng-container>
			<app-validation-errors
				[abstractControl]="control"
			></app-validation-errors>
		</ng-container>
	</ng-container>
</ng-container>
